<script>
export default {
  name: "FaqQues",
  props:{
    faqlist: Array
  },
  methods:{
    addClassActive(event){
      var selectEl = $(event.currentTarget)
      if(selectEl.hasClass("active")){
        selectEl.removeClass("active")
        selectEl.css("height", "9.387rem")
        selectEl.find(".answer").css("height","0")
      }else{
        selectEl.find(".answer").css("height","auto")
        var heightAnswer = selectEl.find(".answer").css("height")
        selectEl.css("height", "calc(" + heightAnswer + " + 9.387rem + 2.903rem + 5.516rem)")
        selectEl.addClass("active")

        selectEl.find(".answer").css("height",heightAnswer)

      }
    }
  },
  mounted() {
  }
}
</script>

<template>
  <div class="faq-box left">
    <h1 class="left flex flex-x-center">Часто задаваемые вопросы</h1>
    <svg class="orange-zig-zag mobile" width="375" height="150" viewBox="0 0 375 150" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M-179 4L95.5855 145.754C96.412 146.18 97.3223 145.346 96.9696 144.486L48.7911 26.9303C48.4728 26.1535 49.1953 25.3539 50.0003 25.5922L349.838 114.36C350.669 114.606 351.399 113.749 351.023 112.968L302.97 13.0179C302.595 12.2385 303.32 11.3831 304.15 11.6243L457 56" stroke="#FF9166" stroke-width="7"/>
    </svg>
    <svg class="blue-zig-zag mobile-nv" width="1920" height="213" viewBox="0 0 1920 213" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M-72 12L809.73 200.302C810.701 200.509 811.348 199.327 810.65 198.621L655.019 41.0445C654.353 40.3702 654.912 39.234 655.852 39.3492L1621.71 157.597C1622.69 157.718 1623.24 156.489 1622.48 155.845L1467.5 23.1406C1466.75 22.4977 1467.29 21.2715 1468.27 21.388L1962 80" stroke="#A6CFF2" stroke-width="24"/>
    </svg>

    <div class="faq-container left flex flex-column">
      <div class="faq left" v-for="item in faqlist" @click="addClassActive">
        <div class="ques left flex flex-y-center">
          <span class="ques-head" v-html="item.title"></span>
          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23" cy="23" r="23" fill="white"/>
            <path d="M24.8315 12.0536L23.0244 13.8607L31.6648 22.5011L10.7211 22.5011L10.7211 25.049L31.6648 25.049L23.0244 33.6894L24.8315 35.4965L36.5529 23.775L24.8315 12.0536Z" fill="#323232"/>
          </svg>
        </div>
        <span class="answer left" v-html="item.desc">
        </span>
      </div>

    </div>
  </div>
</template>

<style scoped>

</style>